import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import OcErrorBoundary from "./OcErrorBoundary";
import "./styles/globals.css";

const ocQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const ocRootElement = document.getElementById("oc-root");
if (!ocRootElement) {
  throw new Error("Missing #oc-root mount node");
}

ReactDOM.createRoot(ocRootElement).render(
  <React.StrictMode>
    <OcErrorBoundary>
      <QueryClientProvider client={ocQueryClient}>
        <App />
      </QueryClientProvider>
    </OcErrorBoundary>
  </React.StrictMode>,
);
